module.exports = __webpack_public_path__ + "img/map-mobile.36e8438c.png";